<div class="contenedor">
    <div class="contenedor_filter">
        <app-filter-table-deals
            (filters)="onSearch($event)"
        ></app-filter-table-deals>
    </div>
    <div class="contenedor_table">   
        <div class="spinner">
            <mat-spinner style="margin-top: 50px;" [diameter]="60" *ngIf="booleanFlag"></mat-spinner>
        </div>

        <app-table-deals *ngIf="!booleanFlag"
            [deals]="result" 
            [page]="resultPage?.page" 
            [pageSize]="resultPage?.pageSize" 
            [totalRows]="resultPage?.totalCount" 
            [sortColumn]="request.sortField" 
            [sortDirection]="request.sortDirection"
            [estadoTrato]="estadoTrato"
            [estadoResolutivo]="estadoResolutivo"
            (pagination)="onPagination($event)"
            (sorting)="onSorting($event)"
            (updateDeals)="getDealsEvaluation()"
            >
        </app-table-deals>
    </div>
</div>